import { Button } from "primereact/button";
import { Message } from "primereact/message";

import { Dialog, DialogHeader } from "@/ds";

import { ConflitoJustificativa } from "../conflito-justificativa";
import { IGNORAR_TITLE } from "./conflito-ignorar-dialog.constants";
import styles from "./conflito-ignorar-dialog.module.scss";
import type { ConflitoIgnorarDialogViewModel } from "./types-conflito-ignorar-dialog";

export function ConflitoIgnorarDialogView({
  formId,
  corpoRef,
  descricao,
  cancelLabel,
  confirmLabel,
  maxLength,
  ocultarDicaObrigatorio,
  justificativa,
  serverError,
  isSubmitting,
  confirmar,
  cancelar,
}: ConflitoIgnorarDialogViewModel) {
  return (
    <Dialog
      visible
      onHide={cancelar}
      locked={isSubmitting}
      header={<DialogHeader title={IGNORAR_TITLE} subtitle={descricao} />}
      footer={
        <div className={styles.footer}>
          <Button
            type="button"
            label={cancelLabel}
            severity="secondary"
            text
            disabled={isSubmitting}
            onClick={cancelar}
            data-testid="ignorar-conflito-cancel"
          />
          <Button
            type="submit"
            form={formId}
            label={confirmLabel}
            loading={isSubmitting}
            data-testid="ignorar-conflito-confirm"
          />
        </div>
      }
      data-testid="ignorar-conflito-dialog"
    >
      <form ref={corpoRef} id={formId} className={styles.body} onSubmit={confirmar} noValidate>
        <ConflitoJustificativa
          id="ignorar-conflito-justificativa"
          value={justificativa.value}
          onChange={justificativa.digitar}
          error={justificativa.error}
          disabled={isSubmitting}
          testId="ignorar-conflito-justificativa"
          maxLength={maxLength}
          hideRequiredHint={ocultarDicaObrigatorio}
        />

        {serverError ? (
          <Message severity="error" text={serverError} data-testid="ignorar-conflito-error" />
        ) : null}
      </form>
    </Dialog>
  );
}
